import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAuth } from './useAuth';
import { AuthPaths } from './AuthConfig';

/**
 * Login/Logout menu component.
 * Shows login button when not authenticated.
 * Shows welcome message and logout button when authenticated.
 */
export const LoginMenu: React.FC = () => {
  const { isAuthenticated, userName, login, logout } = useAuth();
  const { t } = useTranslation();

  if (!isAuthenticated) {
    return (
      <Typography
        style={{ fontSize: '1.1rem', cursor: 'pointer' }}
        variant="h4"
        onClick={() => login()}
      >
        {t('login')}
      </Typography>
    );
  }

  return (
    <>
      <a
        href="/Identity/Account/Manage/ChangePassword"
        style={{ textDecoration: 'none' }}
      >
        <Typography variant="subtitle1" color="inherit">
          {t('welcome')} {userName}
        </Typography>
      </a>

      <Typography
        style={{ fontSize: '1.1rem', cursor: 'pointer' }}
        variant="h4"
        onClick={() => logout()}
      >
        {t('logout')}
      </Typography>
    </>
  );
};
